import React from 'react';
import './Sec1.css';

const Rates = () => (
  <div>
    <br /><br />
    <h2>2024 Fiber Service Rates</h2>
    <h3>Effective January 1, 2024</h3>
    <p>
        New rates effective January 1, 2024 are as follows:
    </p>
    <hr />
    <h4>Internet Service</h4>
    <hr />
    <ul>
      <li>
        Residential 100mbps Advanced Internet Service - $60/mo
      </li>
      <li>
        Residential 400mbps Pro Internet Service - $70/mo
      </li>
      <li>
        Residential Gigabit (1000mbps) Ultra Internet Service - $85/mo
      </li>
      <li>
        Business 100mbps Advanced Internet Service - $85/mo
      </li>
      <li>
        Business 400mbps Pro Internet Service - $250/mo
      </li>
      <li>
        Business Gigabit (1000mbps) Internet Service - $500/mo
      </li>
      <li>
        WiFi Mesh Extender - $5/mo
      </li>
    </ul>
    <hr />
    <h4>Phone Service</h4>
    <hr />
    <ul>
      <li>
        Residential Phone - $30/mo
      </li>
      <li>
        Residential Phone additional line - $20/mo
      </li>
      <li>
        Business Phone - $40/mo
      </li>
      <li>
        Business Phone additional line - $30/mo
      </li>
    </ul>
    <hr />
  </div>
);

export default Rates;


// WEBPACK FOOTER //
// ./src/components/sections/rates.js